import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { UPDATE_BAKER_USER_MUTATION } from '../graphql/mutations/updateBakerUser';
import { GET_BAKER_USERS } from '../graphql/queries/getBakerUsers';
import { GET_BAKER_USER_BY_EMAIL } from '../graphql/queries/getBakerUserByEmail';

export interface UpdateBakerUser {
  email: string;
  profile: string | null;
  inventory?: boolean;
  loans?: boolean;
  lseg?: boolean;
  dailyPricing?: boolean;
  reports?: boolean;
  portfolios?: boolean;
  cashFlows?: boolean;
  swapIQ?: boolean;
  houstonTrust?: boolean;
  empyreanImport?: boolean;
  yieldBookMonitor?: boolean;
}

export const useUpdateBakerUser = () => {
  const [updateUserMutation, { data, loading, error }] = useMutation(UPDATE_BAKER_USER_MUTATION, {
    refetchQueries: [{ query: GET_BAKER_USER_BY_EMAIL }, { query: GET_BAKER_USERS }]
  });

  const updateUser = async (
    {
      email,
      profile,
      inventory,
      loans,
      lseg,
      dailyPricing,
      reports,
      portfolios,
      cashFlows,
      swapIQ,
      houstonTrust,
      empyreanImport,
      yieldBookMonitor
    }: UpdateBakerUser,
    toastMessage?: string
  ) => {
    const variables = {
      bakerUserUpdateDto: {
        email,
        profile,
        inventory,
        loans,
        lseg,
        dailyPricing,
        reports,
        portfolios,
        cashFlows,
        swapIQ,
        houstonTrust,
        empyreanImport,
        yieldBookMonitor
      }
    };

    try {
      await updateUserMutation({ variables });
      toast.success(toastMessage || 'User updated successfully!');
    } catch (err) {
      toast.error('There was an error updating the user.');
    }
  };

  return { updateUser, data, loading, error };
};
